module.exports = __webpack_public_path__ + "static/media/mgo2.5ef1728f.png";